export class cpdTitle {
    ID?: number;    
    Title?: string
    StatusID?: number;
}
